// extracted by mini-css-extract-plugin
export default {"capitalize":"creating-records-view_capitalize__OJvc5"};